
import './App.css';
import Home from "./Pages/home.jsx"
import Privacy from "./section/privacy/Privacy.jsx"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/" element={<Privacy />} />
      </Routes>
    </Router>
  );
}

export default App;

